<app-form-field-wrapper [label]="label" [name]="name" [colSize]="colSize">
  <p-dropdown
    id="defaultColorSet"
    [filter]="true"
    [showClear]="true"
    [(ngModel)]="selection"
    (ngModelChange)="onChange($event)"
    (onChange)="onDropdownChange($event.value)"
    [filterFields]="['name']"
    [options]="colorsets"
    optionLabel="name"
    optionValue="_id">
    <ng-template pTemplate="header">
      @if (enableNewOption) {
        <div class="p-2 border-bottom-1 surface-border">
          <p-button
            styleClass="w-auto"
            [text]="true"
            [rounded]="true"
            (onClick)="openColorsetForm()"
            icon="fas fa-plus"
            label="hinzufügen"></p-button>
        </div>
      }
    </ng-template>
    <ng-template pTemplate="selectedItem" let-selectedOption>
      <div *ngIf="selectedOption" class="flex align-items-center gap-2">
        <div>{{ selectedOption.name }}</div>

        <i
          [class]="'fas fa-circle'"
          [style]="'color:' + color"
          *ngFor="let color of selectedOption.colors"></i>
      </div>
    </ng-template>
    <ng-template let-item pTemplate="item">
      <div class="flex align-items-center gap-2">
        <i class="fas fa-palette"></i>
        <div>{{ item.name }}</div>
        <app-colors [colorset]="item"></app-colors>
      </div>
    </ng-template>
  </p-dropdown>
</app-form-field-wrapper>
